module.exports = __webpack_public_path__ + "media/sub3-5-5.cc6675fd.mp4";